export default __webpack_public_path__ + "static/media/trr-drink-tea-assorted.82910190.png";